export const ItemTypes = {
    CELL: 'cell',
    HIDDEN: 'hidden'
}
